__webpack_require__.p = "/medichain-hms/";